import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonitoramentoJobComponent } from './monitoramento-job.component';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { ToastModule } from 'primeng/toast';

@NgModule({
  imports: [
    CommonModule,
    TableModule,
    PanelModule,
    ToastModule
  ],
  declarations: [MonitoramentoJobComponent]
})
export class MonitoramentoJobModule { }
